export default {
  unavailable: {
    title: 'Este servicio es operado por Foodamigos',
    description:
      'La impresión de folletos y pegatinas es un servicio del equipo de Foodamigos y no está disponible para cuentas de socios.',
  },
};
